import React from 'react';
import logo from '../../images/DevandBeyond_Logo.svg';

const IconLogo = () => (
  <img src={logo} alt="Logo"/>
);

export default IconLogo;
